import React from 'react';
import Image from 'Shared/ImageFallback';
import * as styles from './base.scss';
export default class DescriptionImage extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement("div", { className: styles.descriptionImageContainer },
            React.createElement("div", { className: styles.textContainer }, this.props.text),
            React.createElement("div", { className: styles.imageContainer },
                React.createElement(Image, { src: this.props.imageUrl, className: styles.categoryImage }))));
    }
}
